import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-t-c-modal',
  templateUrl: './t-c-modal.component.html',
  styleUrl: './t-c-modal.component.css',
  standalone: true,
  imports: [CommonModule],
})
export class TCModalComponent {
  type = '';

  constructor(public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.type = this.config.data;
  }
}
